<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Carga de trabajo cantidad de pagos por ejecutivo</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="2">
              <b-form-group 
                :label="crearLabel('Año Consulta', 'anio', 'datosFormulario')"
                label-for="anio">
                <b-form-input
                  id="anio"
                  type="text"
                  placeholder=""
                  v-model="datosFormulario.anio"
                  :disabled="campoBloqueado('anio', 'datosFormulario')"
                  @change="validarCampo('pkg_sinpp_informes', 'anio', $event, 'datosFormulario')">
                </b-form-input>
                <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.anio }}
                </span>
              
              </b-form-group>

            </b-col>

            <b-col sm="2">
                <b-form-group
                  :label="crearLabel('Ejecutivo', 'codejecutivo', 'datosFormulario')"
                  label-for="codejecutivo">
                  <b-form-select 
                    :options="valEjecutivos"  
                    v-model="datosFormulario.codejecutivo"
                    :disabled="campoBloqueado('codejecutivo', 'datosFormulario')"
                  >
                  </b-form-select>
                  
                  <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.codejecutivo }}
                  </span>
                </b-form-group>
            </b-col>

            
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cantidad de indemnizaciones por Ejecutivo por mes y acumulado</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  :min-width="title.minwidth"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cantidad de devoluciones de recuperos por Ejecutivo por mes y acumulado</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data2"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  :min-width="title.minwidth"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

import XLSX from "xlsx";

export default {
  name: "TareasActividades",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      data2: [],
      nombreexcel: "CargaTrabajoCantidadPagosEjecutivo",
      //titlesDinamic: [],
      titles: [
        {
          prop: "Ejecutivo",
          label: "Ejecutivo",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Enero",
          label: "Enero",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Febrero",
          label: "Febrero",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Marzo",
          label: "Marzo",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Abril",
          label: "Abril",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Mayo",
          label: "Mayo",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Junio",
          label: "Junio",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Julio",
          label: "Julio",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Agosto",
          label: "Agosto",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Septiembre",
          label: "Septiembre",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Octubre",
          label: "Octubre",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Noviembre",
          label: "Noviembre",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Diciembre",
          label: "Diciembre",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Total",
          label: "Total",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "Porcentaje",
          label: "Porcentaje",
          align: "right",
          minwidth:'120'
        }
      ],
      filters: [
        {
          prop: ["Ejecutivo",
                 "Enero",
                 "Febrero",
                 "Marzo",
                 "Abril",
                 "Mayo",
                 "Junio",
                 "Julio",
                 "Agosto",
                 "Septiembre",
                 "Octubre",
                 "Noviembre",
                 "Diciembre",
                 "Total",
                 "Porcentaje"
                 ],
          value: ""
        }
      ],


      datosFormulario: {},
      valEjecutivos: [],
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: true,
          maxHeight:600
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];

      return apiInformes
        .pre_insercion_cantidad_pagos_ejecutivo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.codejecutivo = lista_data[i]["codejecutivo"];
              this.datosFormulario.anio = lista_data[i]["anio"];
          }
         
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var lista_tipos_ejecutivos = response.data.ejecutivos;
          for(var i = 0; i < lista_tipos_ejecutivos.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_ejecutivos[i]["codejecutivo"];
              obj.text = lista_tipos_ejecutivos[i]["des_ejecutivo"];
              tiposEjecutivos.push(obj);
          }
          this.valEjecutivos = tiposEjecutivos;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiInformes
        .CargaDeTrabajoCantidadDePagosPorEjecutivo(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.anio, 
          this.datosFormulario.codejecutivo
        )
        .then(response => {
          this.data  = response.data.res1;
          this.data2  = response.data.res2;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }

          
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if ((column.property == "Fecha de asignación" || column.property == "Fecha término") && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if (column.property != "Ejecutivo" && row[column.property]){
        column.align = "is-right";
        return this.$numeral(row[column.property]).format();
      }
      else {
        return row[column.property];
      }
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";


      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Carga de trabajo, cantidad de pagos por ejecutivo</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"' >Año "+this.datosFormulario.anio+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      cuerpo += "</tr>\n";

      //titulo 1
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
          cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
          cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Cantidad de indemnizaciones por Ejecutivo por mes y acumulado</td>\n";
        cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      var sumdata1 = [];
        sumdata1["A1"] = 0;
        sumdata1["A2"] = 0;
        sumdata1["A3"] = 0;
        sumdata1["A4"] = 0;
        sumdata1["A5"] = 0;
        sumdata1["A6"] = 0;
        sumdata1["A7"] = 0;
        sumdata1["A8"] = 0;
        sumdata1["A9"] = 0;
        sumdata1["A10"] = 0;
        sumdata1["A11"] = 0;
        sumdata1["A12"] = 0;
        sumdata1["A13"] = 0;
        sumdata1["A14"] = 0;
      for (var key in this.data) {
          sumdata1["A1"] += this.data[key]["Enero"];
          sumdata1["A2"] += this.data[key]["Febrero"];
          sumdata1["A3"] += this.data[key]["Marzo"];
          sumdata1["A4"] += this.data[key]["Abril"];
          sumdata1["A5"] += this.data[key]["Mayo"];
          sumdata1["A6"] += this.data[key]["Junio"];
          sumdata1["A7"] += this.data[key]["Julio"];
          sumdata1["A8"] += this.data[key]["Agosto"];
          sumdata1["A9"] += this.data[key]["Septiembre"];
          sumdata1["A10"] += this.data[key]["Octubre"];
          sumdata1["A11"] += this.data[key]["Noviembre"];
          sumdata1["A12"] += this.data[key]["Diciembre"];
          sumdata1["A13"] += this.data[key]["Total"];
          sumdata1["A14"] += this.data[key]["Porcentaje"];
          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Ejecutivo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Enero"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Febrero"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Marzo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Abril"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Mayo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Junio"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Julio"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Agosto"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Septiembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Octubre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Noviembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Diciembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key]["Total"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data[key]["Porcentaje"]).format('0,0')+"</td>\n";
          cuerpo += "</tr>\n";
      }
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
          cuerpo += "<td></td>\n";
          cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A1"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A2"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A3"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A4"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A5"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A6"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A7"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A8"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A9"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A10"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A11"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A12"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A13"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A14"]).format('0,0')+"</td>\n";
        cuerpo += "</tr>\n";

      //titulo 2
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
          cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
          cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Cantidad de devoluciones de recuperos por Ejecutivo por mes y acumulado</td>\n";
        cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i].label+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 2
      sumdata1["A1"] = 0;
        sumdata1["A2"] = 0;
        sumdata1["A3"] = 0;
        sumdata1["A4"] = 0;
        sumdata1["A5"] = 0;
        sumdata1["A6"] = 0;
        sumdata1["A7"] = 0;
        sumdata1["A8"] = 0;
        sumdata1["A9"] = 0;
        sumdata1["A10"] = 0;
        sumdata1["A11"] = 0;
        sumdata1["A12"] = 0;
        sumdata1["A13"] = 0;
        sumdata1["A14"] = 0;
      for (var key in this.data2) {
          sumdata1["A1"] += this.data2[key]["Enero"];
          sumdata1["A2"] += this.data2[key]["Febrero"];
          sumdata1["A3"] += this.data2[key]["Marzo"];
          sumdata1["A4"] += this.data2[key]["Abril"];
          sumdata1["A5"] += this.data2[key]["Mayo"];
          sumdata1["A6"] += this.data2[key]["Junio"];
          sumdata1["A7"] += this.data2[key]["Julio"];
          sumdata1["A8"] += this.data2[key]["Agosto"];
          sumdata1["A9"] += this.data2[key]["Septiembre"];
          sumdata1["A10"] += this.data2[key]["Octubre"];
          sumdata1["A11"] += this.data2[key]["Noviembre"];
          sumdata1["A12"] += this.data2[key]["Diciembre"];
          sumdata1["A13"] += this.data2[key]["Total"];
          sumdata1["A14"] += this.data2[key]["Porcentaje"];
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Ejecutivo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Enero"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Febrero"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Marzo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Abril"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Mayo"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Junio"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Julio"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Agosto"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Septiembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Octubre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Noviembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Diciembre"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key]["Total"]+"</td>\n";
            cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.$numeral(this.data2[key]["Porcentaje"]).format('0,0')+"</td>\n";
          cuerpo += "</tr>\n";
      }
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
          cuerpo += "<td></td>\n";
          cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A1"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A2"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A3"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A4"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A5"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A6"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A7"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A8"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A9"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A10"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A11"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A12"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata1["A13"].toFixed()+"</td>\n";
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+this.$numeral(sumdata1["A14"]).format('0,0')+"</td>\n";
        cuerpo += "</tr>\n";

      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
